import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import trackRide from './trackRide';
import { TRACK_RIDE } from 'app/constants';

export default function* watchRideTracking() {
  yield fork(takeLatest, TRACK_RIDE, trackRide);
}
